import React, {useState, useEffect,useContext} from 'react';

const ExportButton = ({showBtnExport,setIsLoading,apiURL,filename}:any) => {

    function exportExcel() 
    {
        setIsLoading(true);
        const token = window.localStorage.getItem('token');
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        fetch(apiURL, { 
            headers,
            method: 'get'
            
        })
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            setIsLoading(false)
            anchor.href = objectUrl;
            anchor.download = filename
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
        });
    };

    return (
        <React.Fragment>   
            <div className="form-group">
                <label> &nbsp;</label>
                <button hidden={showBtnExport}  onClick={() => exportExcel()} className="btn btn-info" type="button">Export</button>
            </div>
        </React.Fragment>   
    )
}

export default ExportButton;